var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.941 8.189c.58.573.83 1.295.947 2.152.112.826.112 1.876.112 3.178v.105c0 1.302 0 2.352-.112 3.178-.117.857-.367 1.579-.947 2.152-.58.573-1.31.82-2.178.935-.835.111-1.898.111-3.216.111h-4.925c-1.318 0-2.38 0-3.216-.111-.868-.115-1.598-.362-2.178-.935a2.985 2.985 0 0 1-.735-1.204c.871.107 1.95.107 3.195.107h5.01c1.281 0 2.385 0 3.27-.117.947-.126 1.856-.41 2.593-1.138.736-.728 1.024-1.626 1.151-2.562.12-.874.12-1.965.119-3.232v-.188c0-1.23 0-2.296-.11-3.158.46.151.868.379 1.22.727Zm-10.748.859c-.932 0-1.687.746-1.687 1.666 0 .92.755 1.667 1.687 1.667.931 0 1.686-.746 1.686-1.667 0-.92-.755-1.666-1.686-1.666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.847 5.837C2 6.674 2 8.02 2 10.714s0 4.041.847 4.878c.847.837 2.21.837 4.936.837h4.82c2.725 0 4.088 0 4.935-.837.847-.837.847-2.184.847-4.878 0-2.693 0-4.04-.847-4.877C16.691 5 15.328 5 12.602 5H7.783c-2.726 0-4.09 0-4.936.837Zm4.213 4.877c0-1.71 1.403-3.095 3.133-3.095s3.132 1.386 3.132 3.095c0 1.71-1.402 3.096-3.132 3.096-1.73 0-3.133-1.386-3.133-3.096Zm8.434 2.62c-.4 0-.723-.32-.723-.715V8.81c0-.394.323-.714.723-.714a.72.72 0 0 1 .723.715v3.81a.719.719 0 0 1-.723.713Zm-11.325-.715c0 .395.323.714.723.714.399 0 .722-.32.722-.714V8.81a.719.719 0 0 0-.722-.714c-.4 0-.723.32-.723.715v3.81Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceActive);
export default __webpack_public_path__ + "static/media/FinanceActive.5d9912aef2bf4f6dc9c92ddc37bf25b2.svg";
export { ForwardRef as ReactComponent };